module.exports = 'ontouchstart' in global || (global.DocumentTouch && document instanceof DocumentTouch)


/*****************
 ** WEBPACK FOOTER
 ** ./~/has-touch/index.js
 ** module id = 1031
 ** module chunks = 0
 **/